import i18n from "lib/i18n";
import PropTypes from "prop-types";
import React from "react";
import getSharedClassNameGenerator from "lib/shared_class_name_generator";
import { ThemeProvider } from "@theconversation/ui";
import { track } from "lib/analytics";

import SubmitForm from "./SubmitForm";
import ToggleLockButton from "../../../components/Editorial/ToggleLockUser/Button";
import ToggleLockDialog from "../../../components/Editorial/ToggleLockUser/Dialog";

export default class ToggleLockUser extends React.Component {
  constructor(props) {
    super(props);

    this.closeModal = this.closeModal.bind(this);
    this.openModal = this.openModal.bind(this);
    this.submitForm = this.submitForm.bind(this);

    this.state = {
      locked: props.locked,
      modalIsOpen: false,
    };
  }

  closeModal() {
    this.setState({ modalIsOpen: false });
  }

  openModal() {
    this.setState({ modalIsOpen: true });
  }

  submitForm(reason) {
    const { afterSubmit, userId } = this.props;
    const { locked } = this.state;

    new SubmitForm({
      locked,
      reason,
      userId,
    }).submit((isLocked) => {
      afterSubmit(isLocked);
      this.setState({ locked: isLocked, modalIsOpen: false });
    });
  }

  render() {
    const { action: trackAction, category: trackCategory, label: trackLabel } = this.props.trackAction;
    const toggleLockText = this.state.locked ?
      i18n.t("editorial_toggle_lock_user.action.unlock") :
      i18n.t("editorial_toggle_lock_user.action.lock");

    return (
      <ThemeProvider generateClassName={getSharedClassNameGenerator()}>
        <ToggleLockButton
          className={this.props.buttonClass}
          locked={this.state.locked}
          onClick={() => {
            track(trackCategory, trackAction, trackLabel);
            this.openModal();
          }}
        >
          {toggleLockText}
        </ToggleLockButton>

        <ToggleLockDialog
          locked={this.state.locked}
          onCancel={this.closeModal}
          onSubmit={this.submitForm}
          open={this.state.modalIsOpen}
          userId={this.props.userId}
          userName={this.props.userName}
        />
      </ThemeProvider>
    );
  }
}

ToggleLockUser.defaultProps = {
  afterSubmit: () => {},
  buttonClass: "",
  trackAction: {
    action: "Click",
    category: "Editorial",
    label: "User Lock",
  },
};

ToggleLockUser.propTypes = {
  afterSubmit: PropTypes.func,
  buttonClass: PropTypes.string,
  locked: PropTypes.bool.isRequired,
  trackAction: PropTypes.shape({
    action: PropTypes.string.isRequired,
    category: PropTypes.string.isRequired,
    label: PropTypes.string.isRequired,
  }),
  userId: PropTypes.oneOfType([
    PropTypes.string, PropTypes.number,
  ]).isRequired,
  userName: PropTypes.string.isRequired,
};

